import React, { useRef, useState } from 'react';

const FloatingLabelInput = ({ id, label, value, onChange, onBlur, error }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const errorId = id ? `${id}-error` : undefined;

  const handleFocus = () => {
    setIsFocused(true);
    inputRef.current.focus();
  }

  return (
    <div className="w-full">
      <div className="relative w-full">
        <label
          htmlFor={id}
          className={`absolute left-3 top-1/2 transform -translate-y-1/2 transition-all duration-300 text-white z-1
          ${isFocused || value ? 'text-base top-[-1px]  bg-tertiary ' : 'text-base'}`}
          onClick={() => !isFocused && handleFocus()}
        >
          {label}
        </label>
        <input
          id={id}
          ref={inputRef}
          type="text"
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur && onBlur(e);
          }}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : undefined}
          className={`p-3 w-full rounded-md bg-tertiary border ${error ? 'border-red-400' : 'border-gray-700'} text-white focus:outline-none placeholder-transparent z-2`}
          placeholder="Name"
        />
      </div>
      {error && (
        <p id={errorId} className="mt-1 text-sm text-red-300">
          {error}
        </p>
      )}
    </div>
  );
};

export default FloatingLabelInput;
